import { render, staticRenderFns } from "./SquareMaterialField.vue?vue&type=template&id=aa23181a&scoped=true&"
import script from "./SquareMaterialField.vue?vue&type=script&lang=ts&"
export * from "./SquareMaterialField.vue?vue&type=script&lang=ts&"
import style0 from "./SquareMaterialField.vue?vue&type=style&index=0&id=aa23181a&scoped=true&lang=scss&"
import style1 from "./SquareMaterialField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa23181a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
